import { Route, Switch } from 'react-router';
import SearchTherapists from './SearchTherapists';
import EditTherapist from './edit';
import ApproveTherapist from './approve';
import UnlockTimesheets from './unlockTimesheets';

const Therapists = () => {
  return (
    <Switch>
      <Route exact path='/admin/therapists' component={SearchTherapists} />
      <Route exact path='/admin/therapists/:id' component={EditTherapist} />
      <Route exact path='/admin/therapists/approve' component={ApproveTherapist} />
      <Route exact path='/admin/therapists/unlockTimesheets' component={UnlockTimesheets} />
    </Switch>
  );
};

export default Therapists;